import { render, staticRenderFns } from "./DocsPageSection.vue?vue&type=template&id=465a7554&scoped=true"
import script from "./DocsPageSection.vue?vue&type=script&lang=js"
export * from "./DocsPageSection.vue?vue&type=script&lang=js"
import style0 from "./DocsPageSection.vue?vue&type=style&index=0&id=465a7554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465a7554",
  null
  
)

export default component.exports